// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Items_pageLayout__2Kxhh"};